import { useState, useEffect } from "react";
import "../../assets/css/gamehis.module.css";
import socket from "../Components/socket";
import AppLoader from "../Components/AppLoader";
import { apiRequest } from "../../apiService/allApi";

const Gamehistory = () => {

  const [user, setUser] = useState();
  let limit = 50;
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const role = async () => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const res = await apiRequest(`me`, "GET", null, headers);
    setUser(res.data);

    Allgames(res.data._id, pageNumber, limit);
  };


  const [game, setGame] = useState([]);

  const Allgames = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    setIsLoading(true);

    try {
      const res = await apiRequest(
        `game/history/user/${id}?page=${pageNumber}&_limit=${limit}`,
        "GET",
        null,
        headers,
      );
      let gameHis = [];
      res.data.data.forEach((ele) => {
        if (
          ele.Status == "completed" ||
          ele.Status == "cancelled" ||
          ele.Status == "conflict"
        ) {
          gameHis.push(ele);
        }
      });
      setGame(gameHis);
      setNumberOfPages(res.data.totalPages);
      setIsLoading(false);
    } catch (e) {}
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${newDate}, ${time}`;
  };

  useEffect(() => {
    role();
  }, [pageNumber, limit]);

  return (
    <div>
      <div
        className="game-history-inner"
        style={{ paddingTop: "0px" }}
      >
        <div
          style={{ paddingBottom: "10vh !important" }}
        >
          {isLoading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "60px 0" }}>
              <AppLoader size="lg" color="primary" text="Loading game history..." />
            </div>
          ) : game && game.length == 0 ? (
            <div className="text-center not_found_box_main">
              <img src="./images/not-found.gif" alt="no data" />
              <div className="mt-2">
                <h3 className="font-weight-bold">No Game History</h3>
                <p>You have no game history yet.</p>
              </div>
            </div>
          ) : (
            game &&
            game.map((card) => (
              <>  
                  <div className="main-card-layout mt-3">
                    <div className="status-side-indicator">
                      <div
                        className={`vertical-line ${
                          card.Status === "completed"
                            ? card.Winner?._id === user._id
                              ? "bg-win"
                              : "bg-loss"
                            : "bg-pending"
                        }`}
                      ></div>
                      <div className="date-content">
                        <span className="day-text">
                          {dateFormat(card.createdAt).split(",")[0]}
                        </span>
                        <span className="time-text">
                          {dateFormat(card.createdAt).split(",")[1]}
                        </span>
                      </div>
                    </div>

                    <div className="game-details-center">
                      <div className="game-header">
                        <span className="game-label">GAME STATUS</span>
                        <h5
                          className={`status-text ${
                            card.Status === "completed"
                              ? card.Winner?._id === user._id
                                ? "text-win"
                                : "text-loss"
                              : "text-pending"
                          }`}
                        >
                          {card.Status === "completed"
                            ? card.Winner?._id === user._id
                              ? "Victory"
                              : "Defeat"
                            : card.Status}
                        </h5>
                      </div>
                      <div className="room-info">
                        <span>
                          Room: <strong>{card.Room_code}</strong>
                        </span>
                      </div>
                    </div>

                    <div className="financials-right">
                      <div className="amount-row">
                        <span className="small-label">Stake</span>
                        <span className="val-text">₹{card.Game_Ammount}</span>
                      </div>

                      <div className="balance-box-new">
                        <span className="small-label-light">Cl Bal</span>
                        <span className="balance-amt">
                          ₹
                          {(card.Acceptor_status === "cancelled" &&
                            card.Accepetd_By?.id === user.id) ||
                          card.Winner?._id === user._id
                            ? card.Winner_closingbalance
                            : card.Loser_closingbalance}
                        </span>
                      </div>

                      {card.Status === "completed" &&
                        card.Winner?._id === user._id && (
                          <div className="win-tag-new">
                            Profit: +₹{card.winnAmount}
                          </div>
                        )}
                    </div>
                  </div>
               
              </>
            ))
          )}
        </div>
      </div>

      
    </div>
  );
};

export default Gamehistory;
